import {
  CONCILIATION_GROUP_LABELS,
  NOT_AVAILABLE,
} from "../../utils/messages";
import { STATUS_VARIANTS } from "../../utils/constants";
import { StatusBadge } from "../shared/status-badge";
import {
  GROUP_BADGE_TEST_ID,
  DERIVED_BADGE_TEST_ID,
} from "../../utils/case-history-test-ids";

interface ConciliationGroupBadgeProps {
  groupId: number | null | undefined;
  derivedFrom: string | null | undefined;
}

export function ConciliationGroupBadge({
  groupId,
  derivedFrom,
}: ConciliationGroupBadgeProps): JSX.Element {
  if (derivedFrom) {
    return (
      <StatusBadge
        variant={STATUS_VARIANTS.DEFAULT}
        data-testid={DERIVED_BADGE_TEST_ID}
        title={CONCILIATION_GROUP_LABELS.DERIVED_TITLE}
      >
        {CONCILIATION_GROUP_LABELS.DERIVED_BADGE}
      </StatusBadge>
    );
  }

  if (!groupId) {
    return <span>{NOT_AVAILABLE}</span>;
  }

  return (
    <StatusBadge
      variant={STATUS_VARIANTS.DEFAULT}
      data-testid={GROUP_BADGE_TEST_ID}
      title={CONCILIATION_GROUP_LABELS.BADGE_TITLE(groupId)}
    >
      {CONCILIATION_GROUP_LABELS.BADGE(groupId)}
    </StatusBadge>
  );
}
